import { render } from "./CenterStats.vue?vue&type=template&id=06bba98c&ts=true"
import script from "./CenterStats.vue?vue&type=script&lang=ts"
export * from "./CenterStats.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Center/CenterStats.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06bba98c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06bba98c', __exports__)) {
    api.reload('06bba98c', __exports__)
  }
  
  module.hot.accept("./CenterStats.vue?vue&type=template&id=06bba98c&ts=true", () => {
    api.rerender('06bba98c', render)
  })

}


export default __exports__